module.exports = __webpack_public_path__ + "img/tibet.f7e498bd.svg";